export function axImplementsInterface(type) {
    var interfaces = this.classInfo.instanceInfo.getInterfaces(this.axClass);
    return interfaces.has(type);
}
